<template>
  <div id="advertisement-stepper">
    <component
      :is="stepToRender"
      @show-notification="$emit('show-notification', $event)"
      @prefill-complete="$emit('prefill-complete')"
    />
  </div>
</template>

<script>
import { computed, nextTick, reactive, watch } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'CheckoutWizard',

  emits: ['continueClicked', 'show-notification', 'prefill-complete'],

  props: {
    steps: {
      type: Array,
      required: true,
    },
    action: {
      type: String,
      default: 'create'
    }
  },

  setup(props) {
    const store = useStore()

    const steps = reactive(props.steps)
    const currentStep = computed(() => store.state.AdvertisementStore.currentStep)
    const currentStepValues = computed(() => steps[currentStep.value])
    const stepToRender = computed(() => currentStepValues.value.component)

    watch(currentStep, () => {
      nextTick(() => {
        const sortingElement = document.querySelector('.sorting.mb-5');
        if (sortingElement) {
          sortingElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      })
    })

    return {
      stepToRender,
      currentStep,
    }
  },
}
</script>
